module.exports = __webpack_public_path__ + "img/2009 feuerwehr winteressen 013.30700cbb.jpg";